import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { StyleProps } from "./selected_tag_chip.types";

export const useStyles = makeStyles<Theme, StyleProps>(() => ({
  chip: {
    marginRight: 8,
  },
  color_circle: {
    backgroundColor: (props) => (props.color ? `#${props.color}` : undefined),
    height: "100%",
    width: "100%",
  },
}));
